'use client'

import { useEffect } from 'react'
import { RouteErrorPanel } from '@/components/status/route-error-panel'
import { useTranslation } from '@/lib/i18n'

/**
 * A crash on an employee-portal page: the product's 500 page, in the portal's
 * own words. What was thrown stays in the console — it is English written for
 * a developer, and the learner reading this page may read Arabic or Hindi.
 */
export default function PortalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { t } = useTranslation()
  useEffect(() => { console.error(error) }, [error])
  return (
    <RouteErrorPanel
      error={error}
      reset={reset}
      title={t('portal.error.title')}
      retryLabel={t('portal.error.tryAgain')}
      secondary={{ label: t('portal.error.backHome'), href: '/', icon: 'home' }}
    />
  )
}
